import React from 'react';
import { Link } from 'react-router-dom';

const FeaturedPost = ({ post }) => {
    return (
        <Link
            to={`/blog/${post.slug}`}
            className="group block p-8 rounded-2xl bg-gradient-to-br from-[var(--color-secondary-accent)] to-[var(--color-primary-accent)] shadow-xl hover:shadow-2xl transition-all duration-300 no-underline hover:no-underline relative overflow-hidden"
            style={{ textDecoration: 'none' }}
        >
            {/* Animated Glow Effect on Hover */}
            <div className="absolute inset-0 bg-white/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

            <div className="relative z-10">
                <div className="inline-block bg-white/10 backdrop-blur-md px-4 py-1.5 rounded-full text-[10px] font-black uppercase tracking-[0.2em] text-white/90 mb-6 border border-white/20">
                    Featured Insight
                </div>

                <h3 className="text-2xl font-black text-white mb-4 leading-tight group-hover:text-white transition-colors tracking-tight">
                    {post.title}
                </h3>

                <p className="text-[#BFDBF7] text-sm leading-relaxed line-clamp-3 group-hover:text-[#BFDBF7] transition-colors font-medium">
                    {post.short_description || post.content.substring(0, 100) + '...'}
                </p>
            </div>
        </Link>
    );
};

export default FeaturedPost;
